var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonderlicLogoLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 212.432 32.574",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wonderlic Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__a",
    x1: -2.916,
    y1: -2.576,
    x2: 1.129,
    y2: 1.064,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__b",
    x1: -2.095,
    y1: -1.834,
    x2: 1.95,
    y2: 1.805,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__c",
    x1: -0.449,
    y1: -0.352,
    x2: 3.596,
    y2: 3.287,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__d",
    x1: 0.376,
    y1: 0.389,
    x2: 4.421,
    y2: 4.028,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__e",
    x1: -1.133,
    y1: -0.727,
    x2: 0.709,
    y2: 0.657,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__f",
    x1: -1.225,
    y1: -0.858,
    x2: 1.339,
    y2: 1.161,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__g",
    x1: -0.359,
    y1: -0.214,
    x2: 2.957,
    y2: 2.539,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__h",
    x1: -1.347,
    y1: -1.163,
    x2: 2.698,
    y2: 2.476,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_light_svg__i",
    x1: -0.697,
    y1: -0.436,
    x2: 1.759,
    y2: 1.482,
    xlinkHref: "#wonderlic_logo_light_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.531 14.281l4.992 13.278 6.869-18.305h-2.337l-4.5 12.109-4.992-13.278-4.992 13.278-4.529-12.11h-2.337l6.869 18.305zm16.146 10.056a8.594 8.594 0 002.868 1.947 9.573 9.573 0 006.869 0 8.426 8.426 0 002.868-1.947 8.527 8.527 0 001.947-2.939 9.733 9.733 0 00.637-3.576 9.544 9.544 0 00-.637-3.541 8.229 8.229 0 00-1.947-2.9 8.594 8.594 0 00-2.868-1.947 9.134 9.134 0 00-3.435-.673 8.494 8.494 0 00-3.434.673 9.368 9.368 0 00-2.868 1.947 8.733 8.733 0 00-1.947 2.9 9.544 9.544 0 00-.637 3.541 9.868 9.868 0 00.637 3.576 8.36 8.36 0 001.946 2.939zm1.664-11.295a6.227 6.227 0 012.054-1.452 6.676 6.676 0 012.549-.5 6.07 6.07 0 012.549.5 5.884 5.884 0 012.054 1.452 6.857 6.857 0 011.381 2.124 7.89 7.89 0 010 5.311 5.638 5.638 0 01-1.381 2.16 6.114 6.114 0 01-2.054 1.416 6.676 6.676 0 01-2.549.5 6.07 6.07 0 01-2.549-.5 5.784 5.784 0 01-2.054-1.416 7.013 7.013 0 01-1.381-2.16 7.891 7.891 0 010-5.311 6.858 6.858 0 011.381-2.124zm18.978 13.348V16.158a5.175 5.175 0 01.6-2.514 4.508 4.508 0 011.664-1.7 4.681 4.681 0 012.479-.6 4.572 4.572 0 012.337.567 3.879 3.879 0 011.522 1.593 5.44 5.44 0 01.531 2.478v10.41h2.443V15.449a6.889 6.889 0 00-.779-3.4 5.378 5.378 0 00-2.124-2.231 6.485 6.485 0 00-3.287-.815 6.67 6.67 0 00-2.3.389 5.15 5.15 0 00-1.806 1.1 5.248 5.248 0 00-1.239 1.664v-2.9h-2.443V26.39zm22.873-17.633a7.667 7.667 0 00-3.257.673 8.42 8.42 0 00-2.726 1.947 8.982 8.982 0 00-1.841 2.9 9.538 9.538 0 00-.6 3.541 10.673 10.673 0 00.6 3.576 9.135 9.135 0 001.841 2.939 8.419 8.419 0 002.726 1.947 8.224 8.224 0 003.257.637 7.739 7.739 0 002.656-.425 6.683 6.683 0 001.983-1.1 5.869 5.869 0 001.275-1.558v2.549h2.443V2.703h-2.444v9.1a5.869 5.869 0 00-1.275-1.558 6.268 6.268 0 00-1.983-1.1 8.4 8.4 0 00-2.656-.389zm0 15.791a5.281 5.281 0 01-2.372-.5 5.728 5.728 0 01-1.947-1.416 6.7 6.7 0 01-1.275-2.16 8.032 8.032 0 01-.425-2.656 6.808 6.808 0 011.7-4.78 5.842 5.842 0 011.947-1.452 5.683 5.683 0 012.372-.5 5.777 5.777 0 014.426 1.947 6.69 6.69 0 011.806 4.78 7.22 7.22 0 01-.46 2.656 6 6 0 01-1.345 2.16 5.531 5.531 0 01-1.983 1.416 5.386 5.386 0 01-2.444.506zm11.436-6.515a10.383 10.383 0 00.567 3.576 7.911 7.911 0 001.735 2.8 7.223 7.223 0 002.691 1.806 9.515 9.515 0 003.4.6 9.223 9.223 0 003.753-.744 8.777 8.777 0 003.01-2.266l-1.629-1.629a10.215 10.215 0 01-1.487 1.345 5.324 5.324 0 01-1.629.779 7.165 7.165 0 01-2.018.248 5.65 5.65 0 01-3.045-.779 5.165 5.165 0 01-2.054-2.124 7.783 7.783 0 01-.85-3.293h13.525c0-.177.035-.354.035-.531v-.567a10.092 10.092 0 00-.531-3.328 7.987 7.987 0 00-1.629-2.723 6.867 6.867 0 00-2.443-1.877 7.253 7.253 0 00-3.08-.6 8.576 8.576 0 00-3.328.637 8.217 8.217 0 00-2.691 1.877 8.437 8.437 0 00-1.77 2.9 11.062 11.062 0 00-.6 3.718v.177zm2.62-1.877a5.241 5.241 0 011.806-3.576 5.981 5.981 0 011.806-1.133 6.109 6.109 0 012.124-.389 4.871 4.871 0 013.576 1.523 4.838 4.838 0 011.487 3.576zm18.8 10.233v-9.948a5.175 5.175 0 01.6-2.514 4.593 4.593 0 011.593-1.7 4.262 4.262 0 012.337-.6 7.7 7.7 0 01.921.035 3.967 3.967 0 01.743.142V9.076c-.142 0-.319-.035-.5-.035s-.354-.035-.531-.035a6.066 6.066 0 00-2.2.389 5.176 5.176 0 00-1.735 1.1 5.735 5.735 0 00-1.2 1.664v-2.9h-2.443V26.39zm9.525-4.32a6.8 6.8 0 00.425 2.585 2.861 2.861 0 001.2 1.487 7.743 7.743 0 00.956.46 4.325 4.325 0 00.921.212 9.356 9.356 0 001.027.071 3.238 3.238 0 00.6-.035c.212-.035.389-.071.566-.106v-2.34l-.531.106c-.212 0-.425.035-.637.035a2.22 2.22 0 01-1.239-.283 1.5 1.5 0 01-.673-.85 3.821 3.821 0 01-.177-1.522V2.703h-2.443zm11.012-16.144a1.793 1.793 0 00.425-1.664 1.576 1.576 0 00-.425-.744 1.646 1.646 0 00-.743-.46 1.587 1.587 0 00-.814 0 1.392 1.392 0 00-.744.46 1.577 1.577 0 00-.425.744 1.87 1.87 0 000 .885 1.689 1.689 0 00.425.779 1.628 1.628 0 001.558.425 2 2 0 00.743-.425zm.071 20.465V9.253h-2.443V26.39zm11.932-17.633a8.494 8.494 0 00-3.434.673 9.368 9.368 0 00-2.868 1.947 8.732 8.732 0 00-1.947 2.9 9.543 9.543 0 00-.637 3.541 9.868 9.868 0 00.637 3.576 8.359 8.359 0 001.947 2.939 8.6 8.6 0 002.868 1.947 9.118 9.118 0 003.434.637 9.227 9.227 0 003.505-.637 7.552 7.552 0 002.8-1.947l-1.487-1.77a5.918 5.918 0 01-2.16 1.487 7.282 7.282 0 01-2.691.5 6.07 6.07 0 01-2.549-.5 5.786 5.786 0 01-2.054-1.416 7.012 7.012 0 01-1.381-2.16 7.89 7.89 0 010-5.311 5.263 5.263 0 011.381-2.124 6.228 6.228 0 012.054-1.452 6.677 6.677 0 012.549-.5 7.282 7.282 0 012.691.5 6.93 6.93 0 012.16 1.487l1.487-1.77a7.989 7.989 0 00-2.8-1.947 9.827 9.827 0 00-3.505-.599zm9.064 17.385a1.627 1.627 0 002.3 0 1.793 1.793 0 00.425-1.664 1.575 1.575 0 00-.425-.744 1.646 1.646 0 00-.743-.46 1.587 1.587 0 00-.814 0 1.392 1.392 0 00-.744.46 1.576 1.576 0 00-.425.744 1.869 1.869 0 000 .885 1.15 1.15 0 00.426.779z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.66 29.879a4.49 4.49 0 11-4.674 4.178 4.447 4.447 0 014.674-4.178z",
    transform: "translate(-126.222 -29.867)",
    fill: "url(#wonderlic_logo_light_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46 29.879a4.49 4.49 0 11-4.674 4.178 4.447 4.447 0 014.674-4.178z",
    transform: "translate(-102.193 -29.867)",
    fill: "url(#wonderlic_logo_light_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.96 29.879a4.49 4.49 0 11-4.674 4.178 4.447 4.447 0 014.674-4.178z",
    transform: "translate(-54.071 -29.867)",
    fill: "url(#wonderlic_logo_light_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.66 29.879a4.49 4.49 0 11-4.674 4.178 4.447 4.447 0 014.674-4.178z",
    transform: "translate(-29.978 -29.867)",
    fill: "url(#wonderlic_logo_light_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.228 76.872a4.2 4.2 0 01-.814-5.807l11.613-15.9a4.006 4.006 0 015.665-.85 4.2 4.2 0 01.814 5.807l-11.613 15.9a3.942 3.942 0 01-5.665.85z",
    transform: "translate(-94.972 -45.136)",
    fill: "url(#wonderlic_logo_light_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.028 69.082a4.2 4.2 0 01-.814-5.807l5.913-8.108a4.006 4.006 0 015.665-.85 4.2 4.2 0 01.814 5.807l-5.913 8.144a3.969 3.969 0 01-5.665.814z",
    transform: "translate(-81.278 -45.136)",
    fill: "url(#wonderlic_logo_light_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.628 64.621a4.2 4.2 0 01-.814-5.807l2.656-3.647a4.006 4.006 0 015.665-.85 4.2 4.2 0 01.814 5.807l-2.656 3.647a3.942 3.942 0 01-5.665.85z",
    transform: "translate(-39.034 -45.136)",
    fill: "url(#wonderlic_logo_light_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.06 49.479a4.49 4.49 0 11-4.674 4.178 4.447 4.447 0 014.674-4.178z",
    transform: "translate(-68.992 -42.528)",
    fill: "url(#wonderlic_logo_light_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.628 89.468a4.2 4.2 0 01-.814-5.807l6.55-8.993a4.006 4.006 0 015.665-.85 4.2 4.2 0 01.814 5.807l-6.55 8.993a3.938 3.938 0 01-5.665.85z",
    transform: "translate(-46.785 -57.731)",
    fill: "url(#wonderlic_logo_light_svg__i)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonderlicLogoLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonderlic_logo_light.5baf154c60dfe08cf8c159cdfafa93e1.svg";